/**
 * Farbiger Staffing-Status (#158): offen rot, vorgeschlagen orange, Float gelb, erledigt grün,
 * ausgeplant grau, zu bestätigen (#163, KI-Vorschlag) im Warnton. Farben als Tokens
 * `--staffing-<status>` in `styles/tokens/` (beide Themes), Text `v2.staffing_maske.status.<status>`.
 */
import type { StaffingAnzeigeStatus } from '@projektverwaltung/shared';
import type { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

export function statusFarbe(status: StaffingAnzeigeStatus): CSSProperties {
  return {
    background: `var(--staffing-${status}-soft)`,
    color: `var(--staffing-${status})`,
  };
}

export function useStatusText(): (status: StaffingAnzeigeStatus) => string {
  const { t } = useTranslation();
  return (status) => t(`v2.staffing_maske.status.${status}`, status);
}

export function StatusBadge({ status }: { status: StaffingAnzeigeStatus }) {
  const text = useStatusText();
  return (
    <span
      className="inline-flex shrink-0 items-center rounded px-1.5 py-0.5 text-[10px] uppercase tracking-[0.08em]"
      style={{ ...statusFarbe(status), fontFamily: 'var(--f-mono)' }}
    >
      {text(status)}
    </span>
  );
}
